export default "__VITE_ASSET__53a71153__"